import { Util } from "@base/util/Util";
import { BeosInputRawAuslieferungsart } from "@biz/definitions/BeosServiceDefinitions";
import { OrderState, OrderStateHelper } from "@biz/definitions/DatabaseDefinitions";
import { ProductionLocation } from "@biz/definitions/SunSailDefinitions";
import { IExtOrders } from "@biz/models/SceneOrderHelper";

export interface IExternalOrderOld {
  id: string;
  productIndex: number;
  subIndex: number;
  processed: number | undefined;
  shippingDate?: number;
  state?: OrderState;
  expectedShippingDate?: number;
  auslieferungsart?: BeosInputRawAuslieferungsart;
  productionLocation?: ProductionLocation;
}

export type ExternalOrdersOld = IExternalOrderOld[];
export interface IExternalOrdersSource {
  /** @depreacted */
  externalOrders?: ExternalOrdersOld;
  extOrders?: IExtOrders;
}

export class ExternalOrderHelper {
  static toShortId(id: string): string {
    return id.substr(0, 7);
  }

  static toLongId(id: string): string {
    return id;
  }

  static split(id: string): { front: string; mid: string, back: string } {
    return {
      front: ExternalOrderHelper.toShortId(id),
      mid: id.substr(7, 3),
      back: id.substr(10),
    }
  }

  static getIdForOrderIndex(orders: ExternalOrdersOld | undefined, index?: number): string {
    const _index = index || 0;
    if (!orders) return "";
    if (_index >= orders.length) return "";
    return orders[_index].id;
  }

  static isProcessedForIndex(orders: ExternalOrdersOld | undefined, index?: number): boolean {
    const _index = index || 0;
    if (!orders) return false;
    if (_index >= orders.length) return false;
    return !!orders[_index].processed;
  }

  static ensureSizeOld(orders: ExternalOrdersOld | undefined, length: number): ExternalOrdersOld {
    const preparedOrders = Util.ensureArrayWithSize(orders, length, (index,) => ({ id: "", processed: undefined, productIndex: index, subIndex: 0 }));
    return preparedOrders;
  }

  static allIdsFilled(extOrders: IExtOrders | undefined): boolean | undefined {
    if (!extOrders) return undefined;
    for (const order of extOrders.orderSlots) {
      if (!order.order?.as400Id)
        return false;
    }
    return true;
  }

  static allStatesExact(extOrders: IExtOrders | undefined, targetState: OrderState): boolean {
    if (!extOrders) return false
    for (const order of extOrders.orderSlots) {
      const state = order.order?.state;
      if (!state)
        return false;
      if (state !== targetState)
        return false;
    }
    return true;
  }

  static allStatesAtLeast(extOrders: IExtOrders | undefined, targetState: OrderState): boolean {
    if (!extOrders) return false
    for (const order of extOrders.orderSlots) {
      const state = order.order?.state;
      if (!state)
        return false;
      if (state === OrderState.Cancelled || !OrderStateHelper.ge(state, targetState))
        return false;
    }
    return true;
  }
}
